import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/public/HomeView')
  },
  {
    path: '/home',
    name: 'homeView',
    component: () => import('../views/public/HomeView')
  },
  {
    path: "/registration-masukkan-otp",
    name: "RegistrationMasukkanOtp",
    component: () => import("../views/registration/RegistrationMasukanOtpView.vue"),
  },
  {
    path: "/registation-active",
    name: "RegistrationActive",
    component: () => import("../views/registration/RegistrationActiveView.vue"),
  },

  {
    path: "/reset-atur-ulang",
    name: "ResetAturUlang",
    component: () => import("../views/reset-password/ResetAturUlangView.vue"),
  },
  {
    path: "/reset-metode-verifikasi",
    name: "ResetAturUlang",
    component: () => import("../views/reset-password/ResetMetodeVerifikasiView.vue"),
  },
  {
    path: "/select-account-type",
    name: "SelectAccountType",
    component: () => import("../views/registration/SelectAccountTypeView.vue"),
  },
  // {
  //   path: "/reset-masukkan-otp",
  //   name: "ResetMasuukanOtp",
  //   component: () => import("../views/reset-password/ResetMasukanOtpView.vue"),
  // },
  {
    path: "/reset-masukkan-otp-password",
    name: "ResetMasukanOtpPaswordView",
    component: () => import("../views/reset-password/ResetMasukanOtpPasswordView.vue"),
  },
  {
    path: "/reset-success",
    name: "ResetSuccess",
    component: () => import("../views/reset-password/ResetSuccessView.vue"),
  },

  {
    path: "/reset-metode-verifikasi",
    name: "ResetMetodeVerifikasiView",
    component: () => import("../views/reset-password/ResetMetodeVerifikasiView.vue"),
  },
  {
    path: "/reset-new-password",
    name: "ResetNewPassword",
    component: () => import("../views/reset-password/ResetNewPasswordView.vue"),
  },
  {
    path: "/verifikasi-login-link/:encryptedTimeOut/:encryptedUserId",
    name: "VerifikasiLoginLinkView",
    component: () => import("../views/public/VerifikasiLoginLinkView.vue"),
  },
  {
    path: "/verifikasi-login-link-send",
    name: "VerifikasiLoginLinkSendView",
    component: () => import("../views/public/VerifikasiLoginLinkSendView.vue"),
  },
  {
    path: "/admin-setting-one",
    name: "AdminSettingOne",
    component: () => import("../views/admin/SettingOneView.vue"),
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/registration/RegistrationView.vue"),
  },
  {
    path: '/dashboard-utama',
    name: 'DashboardUtama',
    component: () => import('../views/Dashboard')
  },
  {
    path: '/login',
    name: 'Login',
    component: () =>
        import ('../views/LoginView.vue')
  },
  {
    path: '/change-profile',
    name: 'ChangeProfile',
    component: () =>
        import ('../views/admin/ChangeProfile'),
  },
  {
    path: '/setup-visitor',
    name: 'SetupVisitor',
    // lazy-loaded
    component: () => import('../views/admin-setup/FVisitorView.vue')
  },
  {
    path: '/admin-insentif',
    name: 'AdminInsentifView',
    // lazy-loaded
    component: () => import('../views/admin-insentif/AdminInsentifView.vue' +
    '')
  },
  {
    path: '/admin-sistem',
    name: 'AdminSistem',
    component: () =>
        import ('../views/admin/SettingAndUser.vue')
  },
  {
    path: '/admin-struktur-organisasi',
    name: 'StrukturOrganisasi',
    component: () =>
        import ('../views/admin/StrukturOrganisasi.vue')
  },



  {
    path: '/admin-jenis-infrastruktur',
    name: 'AdminJenisInfrastruktur',
    component: () => import('../views/admin_infra/InfrastructureTypeView')
  },
  {
    path: '/admin-infrastruktur',
    name: 'AdminInfrastructure',
    component: () => import('../views/admin_infra/InfrastructureView')
  },
  {
    path: '/admin-jenis-dayadukung',
    name: 'AdminJenisDayaDukung',
    component: () => import('../views/admin_dayadukung/DayaDukungTypeView')
  },
  {
    path: '/admin-dayadukung',
    name: 'AdminDayaDukung',
    component: () => import('../views/admin_dayadukung/DayaDukungView')
  },
  {
    path: '/admin-sector-type',
    name: 'AdminSectorType',
    component: () => import('../views/admin_other/SectorType')
  },

  {
    path: '/admin-komoditi',
    name: 'AdminKomoditiView',
    component: () => import('../views/admin_komoditi/KomoditiView')
  },
  {
    path: '/admin-komoditi-type',
    name: 'AdminKomoditiType',
    component: () => import('../views/admin_komoditi/KomoditiTypeView')
  },
  {
    path: '/admin-potensi',
    name: 'AdminPotensi',
    component: () => import('../views/admin_potensi/PotensiView')
  },
  {
    path: '/admin-kawasan',
    name: 'AdminKawasan',
    component: () => import('../views/admin_potensi/KawasanView')
  },

  {
    path: '/admin-wilayah',
    name: 'RegionView',
    component: () => import('../views/wilayah/RegionView')
  },
  {
    path: '/admin-din-carousel',
    name: 'DinCarouselView',
    component: () => import('../views/admin-setup/DinCarouselView.vue')
  },
  {
    path: '/chart-visitor',
    name: 'ChartVisitorView',
    component: () =>
        import ('../views/public/ChartVisitorView')
},



  {
    path: '/public-potensi-detail/:id',
    name: 'PotensiDetailView',
    component: () =>
        import ('../views/public/PotensiDetailView')
  },
  {
    path: '/public-peluang-investasi',
    name: 'PublicPeluangInvestasi',
    component: () => import('../views/public/PotensiPeluangView')
  },
  {
    path: '/public-insentif',
    name: 'PublicInsentifView',
    component: () => import('../views/public/InsentifView.vue')
  },
  {
    path: '/public-ipro',
    name: 'PotensiPeluangView',
    component: () => import('../views/public/PotensiPeluangView')
  },
  {
    path: '/public-potensi',
    name: 'PotensiView',
    component: () => import('../views/public/PotensiView')
  },

  {
    path: '/public-komoditi',
    name: 'PublicKomoditi',
    component: () => import('../views/public/KomoditiView')
  },
  {
    path: '/public-dayadukung',
    name: 'PublicDayaDukung',
    component: () => import('../views/public/DayaDukungView')
  },
  {
    path: '/public-profil-daerah',
    name: 'PublicProfilDaerahView',
    component: () => import('../views/public/ProfilDaerahView')
  },
  {
    path: '/public-profil-daerah-detil/:id',
    name: 'PublicProfilDaerahDetilView',
    component: () => import('../views/public/ProfilDaerahDetilView')
  },

  {
    path: '/public-infrastruktur',
    name: 'PublicInfrastructur',
    component: () => import('../views/public/InfrastrukturView')
  },

  {
    path: '/setup-satuan',
    name: 'SetupSatuan',
    // lazy-loaded
    component: () => import('../components/setup/satuan/FSatuanTable')
  },

  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  /**
   * UMKM BERMITRA
   */
  {
    path: "/user-umkm-profile",
    name: "UserUmkmProfileView",
    component: () => import("../views/user-umkm/UserUmkmProfileView.vue"),
  },
  {
    path: '/public-umkm-siap-bermitra',
    name: 'UmkmBermitraView',
    component: () => import('../views/public-umkm/UmkmBermitraView.vue')
  },
  {
    path: '/public-umkm-siap-bermitra-detail/:id',
    name: 'ObjectDetailView',
    component: () =>
        import ('../views/public-umkm/ObjectDetailView')
  },

  {
    path: '/admin-umkm-type',
    name: 'UmkmTypeView',
    component: () =>
        import ('../views/admin-umkm/UmkmTypeView.vue')
  },
  {
    path: '/admin-umkm-object',
    name: 'AdminUmkmObjectView',
    // lazy-loaded
    component: () => import('../views/admin-umkm/DaftarUmkmView.vue')
  },
  {
    path: '/setup-permit-umkm',
    name: 'SetupPermitView',
    component: () => import('../views/setup-umkm/PermitView.vue')
  },

  //E-Library
  {
    path: '/public-e-library',
    name: 'ElibraryView',
    component: () =>
        import ('../views/public-e-library/ElibraryView.vue')
  },
  {
    path: "/admin-article-categ",
    name: "ArticleCategView",
    component: () =>
        import(
            /* webpackChunkName: "about" */ "../views/admin-e-library/ArticleCategView.vue"
            ),
  },
  {
    path: "/admin-article",
    name: "ArticleView",
    component: () =>
        import(
            /* webpackChunkName: "about" */ "../views/admin-e-library/ArticleView.vue"
            ),
  },
  {
    path: '/public-e-library/produk-hukum',
    name: 'ElibraryProdukHukumView',
    component: () =>
        import ('../views/public-e-library/ElibraryProdukHukumView.vue')
  },
  {
    path: '/public-e-library/buku',
    name: 'ElibraryBukuView',
    component: () =>
        import ('../views/public-e-library/ElibraryBukuView.vue')
  },
  {
    path: '/public-e-library/jurnal',
    name: 'ElibraryJurnalView',
    component: () =>
        import ('../views/public-e-library/ElibraryJurnalView.vue')
  },
  {
    path: '/public-e-library/buletin',
    name: 'ElibraryBuletinView',
    component: () =>
        import ('../views/public-e-library/ElibraryBuletinView.vue')
  },
  {
    path: '/public-e-library/artikel',
    name: 'ElibraryArtikelView',
    component: () =>
        import ('../views/public-e-library/ElibraryArtikelView.vue')
  },
  {
    path: '/public-e-library-detil/:id',
    name: 'ElibraryDetilView',
    component: () =>
        import ('../views/public-e-library/ElibraryDetilView.vue')
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
